module.exports = __webpack_public_path__ + "assets/units/sprites/Snow Bunny - Freezing Spit.png";